import React, { useState, useEffect } from "react";
import moment from "moment";
import HeaderLogadoColaborador from "../../../../components/common/Authenticated/Colaborador/Header/HeaderLogadoColaborador"
import api from "../../../../services/api";
import CardBloqueio from "../../../../components/Authenticated/Colaborador/BloqueioAgenda/CardBloqueio";
import BottomMenuColaborador from "../../../../components/common/Authenticated/Colaborador/Menu/Menu";

const BloqueioAgenda = () => {
  const usuarioStorage = JSON.parse(localStorage.getItem("usuario")) || {};
  const [modalVisible, setModalVisible] = useState(false);
  const [inicio, setInicio] = useState(moment().format("YYYY-MM-DDTHH:mm"));
  const [fim, setFim] = useState(moment().format("YYYY-MM-DDTHH:mm"));
  const [recorrencia, setRecorrencia] = useState("nao");
  const [showRecorrencia, setShowRecorrencia] = useState(false);
  const [recorrenciaOptions, setRecorrenciaOptions] = useState([
    { label: "Diária", value: "diaria" },
    { label: "Semanal", value: "semanal" },
    { label: "Mensal", value: "mensal" },
    { label: "Anual", value: "anual" }
  ]);
  const [bloqueios, setBloqueios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);

  const fetchBloqueios = async () => {
    try {
      const response = await api.get(`/bloqueio-agenda/${usuarioStorage._id}`);
      if (response.status === 200) {
        setBloqueios(response.data.bloqueios);
      } else {
        alert("Erro ao buscar bloqueios");
      }
    } catch (error) {
      alert("Erro ao conectar ao servidor");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBloqueios();
  }, []);

  // Validação de recorrência
  useEffect(() => {
  const diffDays = (new Date(fim) - new Date(inicio)) / (1000 * 60 * 60 * 24);

  const updatedOptions = [
    ...(diffDays <= 1 ? [{ label: "Diária", value: "diaria" }] : []),
    ...(diffDays <= 7 ? [{ label: "Semanal", value: "semanal" }] : []),
    ...(diffDays <= 30 ? [{ label: "Mensal", value: "mensal" }] : []),
    ...(diffDays <= 365 ? [{ label: "Anual", value: "anual" }] : []),
  ];

  setRecorrenciaOptions(updatedOptions);

  // Resetar recorrência se a opção atual não é mais válida
  if (!updatedOptions.some(opt => opt.value === recorrencia)) {
    setRecorrencia("nao");
  }

  // Desmarcar checkbox apenas se não houver nenhuma opção válida
  if (updatedOptions.length === 0) {
    setShowRecorrencia(false);
  }
}, [inicio, fim]);

  const handleSubmit = async () => {
    if (fim < inicio) {
      alert("A data/horário de fim não pode ser anterior à data/horário de início.");
      return;
    }

    const data = {
      colaboradorId: usuarioStorage._id,
      inicio: new Date(inicio).toISOString(),
      fim: new Date(fim).toISOString(),
      recorrencia: showRecorrencia ? recorrencia : "nao"
    };

    try {
      const response = await api.post("/bloqueio-agenda/", data);
      if (response.status === 200) {
        alert("Bloqueio cadastrado com sucesso");
        fetchBloqueios();
        setModalVisible(false);
      } else {
        alert("Erro ao cadastrar bloqueio");
      }
    } catch (error) {
      alert("Erro ao conectar ao servidor");
    }
  };

  const handleDelete = async (id) => {
    try {
      const response = await api.delete(`/bloqueio-agenda/${id}`);
      if (response.status === 200) {
        setBloqueios(bloqueios.filter(b => b._id !== id));
        alert("Bloqueio excluído com sucesso");
      } else {
        alert("Erro ao excluir bloqueio");
      }
    } catch (error) {
      alert("Erro ao conectar ao servidor");
    }
  };

  const capitalizeFirstLetter = (string) =>
    string.charAt(0).toUpperCase() + string.slice(1);

  return (
    <>
        <HeaderLogadoColaborador />
        <div className="p-5 space-y-1 bg-white min-h-svh">
        <h1 className="text-3xl font-bold mb-6 text-[#003D42]">Bloqueios de Agenda</h1>
        <p className="text-md text-gray-500 mt-1 mb-6">Visualize e gerencie os períodos indisponíveis da sua agenda.</p>



        {loading ? (
  <div className="flex flex-col items-center justify-center bg-white">
    <div className="loader mb-4"></div>
    <p className="text-lg">Buscando bloqueios...</p>
  </div>
) : bloqueios.length === 0 ? (
  <p className="text-center text-gray-500">Não há nenhum bloqueio cadastrado.</p>
) : (
  <div className="flex flex-wrap justify-center gap-4 pb-4 pt-2">
    {bloqueios.map((b) => (
      <CardBloqueio
        key={b._id}
        inicio={moment(b.inicio).format("DD/MM/YYYY HH:mm")}
        fim={moment(b.fim).format("DD/MM/YYYY HH:mm")}
        recorrencia={capitalizeFirstLetter(
          b.recorrencia === "nao" ? "não" : b.recorrencia
        )}
        id={b._id}
        onDelete={() => handleDelete(b._id)}
        onDeleteSuccess={fetchBloqueios}
      />
    ))}
  </div>
)}


<div className="flex justify-center mt-6">
  <button
    onClick={() => setModalVisible(true)}
    className="bg-[#003D42] text-white px-6 py-3 rounded-lg hover:bg-[#005c62] active:bg-[#002a30] transition-colors font-semibold shadow-md max-w-lg"
  >
    Adicionar Bloqueio
  </button>
</div>


        {/* Modal */}
        {modalVisible && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-xl w-full max-w-md">
                <h2 className="text-xl font-bold mb-4 text-center">Cadastrar Bloqueio</h2>

                <div className="flex flex-col mb-4">
                <label className="font-semibold mb-1">Início do bloqueio</label>
                <input
                    type="datetime-local"
                    className="border p-2 rounded-md"
                    value={inicio}
                    onChange={(e) => setInicio(e.target.value)}
                />
                </div>

                <div className="flex flex-col mb-4">
                <label className="font-semibold mb-1">Fim do bloqueio</label>
                <input
                    type="datetime-local"
                    className="border p-2 rounded-md"
                    value={fim}
                    onChange={(e) => setFim(e.target.value)}
                />
                </div>

                <div className="flex items-center mb-4">
                  <div className="flex items-center gap-2">
                    <input
                    type="checkbox"
                    checked={showRecorrencia}
                    onChange={() => {
                      const newValue = !showRecorrencia;
                      setShowRecorrencia(newValue);
                      if (!newValue) setRecorrencia("nao"); // reset quando desmarca
                    }}
                    className="w-4 h-4 text-[#003D42] accent-[#003D42]"
                  />
                    <span className="text-gray-800 font-medium">Recorrente</span>
                  </div>

                </div>

                {showRecorrencia && (
                <div className="flex flex-col mb-4">
                    <label className="font-semibold mb-1">Tipo de Recorrência</label>
                    <select
                    className="border p-2 rounded-md"
                    value={recorrencia}
                    onChange={(e) => setRecorrencia(e.target.value)}
                    >
                    {recorrenciaOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                        {option.label}
                        </option>
                    ))}
                    </select>
                </div>
                )}

                <div className="flex justify-end mt-6 gap-3">
                {/* Botão secundário */}
                <button
                    onClick={() => setModalVisible(false)}
                    className="bg-gray-200 text-gray-700 px-5 py-2 rounded-lg hover:bg-gray-300 active:bg-gray-400 transition-colors font-medium"
                >
                    Cancelar
                </button>

                {/* Botão principal */}
                <button
                    onClick={handleSubmit}
                    className="bg-[#003D42] text-white px-5 py-2 rounded-lg hover:bg-[#005c62] active:bg-[#002a30] transition-colors font-semibold shadow-sm"
                >
                    Cadastrar
                </button>
                </div>
            </div>
            </div>
        )}
        
        </div>
        <BottomMenuColaborador />
    </>
  );
};

export default BloqueioAgenda;
